import { FETCH_FLASHCARD_BODY } from '../constants/actionTypes';

const flashcardBody = (flashcardBody = [], action) => {
  switch (action.type) {
    case FETCH_FLASHCARD_BODY:
      return action.payload;
    default:
      return flashcardBody;
  }
};

export default flashcardBody;
